import styled from 'styled-components';
import {
    DARK_GREEN,
    SWEGON_GREEN,
    WHITE
} from '@swegon-core/uic/dist/src/theme';

export const Container = styled.div`
    width: 100vw;
    height: 100vh;
    padding: 1rem;
    background-color: ${WHITE};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Content = styled.div`
    display: grid;
    grid-template-rows: 0.5fr 0.5fr 0.5fr 0.5fr;
`;

export const Title = styled.h4`
    text-align: center;
`;

export const Description = styled.div`
    > p {
        font-size: 1rem;
        text-align: center;
    }
`;

export const ButtonContainer = styled.h5`
    display: flex;
    justify-content: center;
`;

export const LinkButton = styled.a`
    display: inline-flex;
    align-items: center;
    padding: 0px 32px;
    min-height: 40px;
    background-color: ${WHITE};
    border: 1px solid ${DARK_GREEN};
    font: 0.875rem 'SwegonBrown';
    color: ${DARK_GREEN};
    text-decoration: none;

    &:hover {
        background-color: ${SWEGON_GREEN};
        border-color: ${SWEGON_GREEN};
        color: ${WHITE};
    }
`;
